import { Component, OnInit } from '@angular/core';
import { delay, timeout } from 'rxjs/operators';
import { interval } from 'rxjs';

@Component({
  selector: 'mini-spinner',
  templateUrl: './mini-spinner.component.html',
  styleUrls: ['./mini-spinner.component.css']
})
export class MiniSpinnerComponent implements OnInit {


  estado: number = 0;
  auxiliar: number = 0;

  constructor() { }

  ngOnInit(): void {

    const seconds = interval(100);
    seconds.pipe(timeout(110))      // Let's use bigger timespan to be safe,
      // since `interval` might fire a bit later then scheduled.
      .subscribe(
        value => {
          this.estado = this.auxiliar
          this.auxiliar += 1;
          if (this.auxiliar == 8) {
            this.auxiliar = 0;
          }
          
        }, // Will emit numbers just as regular `interval` would.
        err => console.log(err),     // Will never be called.
      );
  }

}
